(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/tur/ball/assets/javascripts/prescript.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.helpers = svs.tur.ball.helpers || {};
svs.tur.ball.helpers.RandomNumber = function () {
  let min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  let max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 70;
  return _.random(min, max);
};
svs.tur.ball.helpers.generateArray = function () {
  let length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7;
  let min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  let max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 70;
  return _.shuffle(_.sample(_.range(min, max), length));
};
svs.tur.ball.helpers.generateArraySpinNumbers = function () {
  let ballsToSpin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7;
  let min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  let max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 70;
  let correctNumber = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  const numArray = [];
  correctNumber = min === 0 ? correctNumber - 1 : correctNumber;
  for (let i = min; i < ballsToSpin; i++) {
    let numVal = correctNumber - i;
    if (numVal < min) {
      if (-1 * numVal >= max) {
        numVal = max + (numVal + max);
      } else {
        numVal = max + numVal;
      }
    }
    numArray.push(numVal);
  }
  return numArray;
};
svs.tur.ball.helpers.RandomArray = function () {
  let length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7;
  let min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  let max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 70;
  let lengthExtra = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  let kungKeno = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  const obj = {
    _min: min,
    _max: max,
    _length: length,
    _lengthExtra: lengthExtra,
    _kungKeno: kungKeno
  };
  obj.numbers = svs.tur.ball.helpers.generateArray(length, min, max);
  if (lengthExtra) {
    obj.extraNumbers = svs.tur.ball.helpers.generateArray(lengthExtra, min, max);
  }
  if (kungKeno) {
    obj.kungKeno = _.sample(obj.numbers, 1);
  }
  return obj;
};
svs.tur.ball.helpers.RandomArrayFrom = function (arr, numberLength, extraNumberLength, numbersCorrect, extraNumbersCorrect, kungKenoCorrect) {
  const obj = {};
  let correctNumbers;
  if (kungKenoCorrect && arr.kungKeno) {
    correctNumbers = _.shuffle(_.sample(_.reject(arr.numbers, num => num === arr.kungKeno[0]), numbersCorrect - 1).concat(arr.kungKeno));
    if (numbersCorrect <= 1) {
      correctNumbers = arr.kungKeno;
    }
  } else {
    correctNumbers = _.sample(arr.numbers, numbersCorrect);
  }
  const correctExtraNumbers = _.sample(arr.extraNumbers, extraNumbersCorrect);
  const numbers = _.shuffle(_.range(arr._min, arr._max));
  const correctArray = correctNumbers;
  const correctExtraArray = correctExtraNumbers;
  for (let i = 0; i < numbers.length; i++) {
    if (correctArray.length < numberLength) {
      if (!correctArray.includes(numbers[i]) && !arr.numbers.includes(numbers[i])) {
        correctArray.push(numbers[i]);
      }
    } else {
      break;
    }
  }
  for (let i = 0; i < numbers.length; i++) {
    if (correctExtraArray.length < extraNumberLength) {
      if (!correctExtraArray.includes(numbers[i]) && !arr.numbers.includes(numbers[i])) {
        correctExtraArray.push(numbers[i]);
      }
    } else {
      break;
    }
  }
  obj.correctArray = correctArray;
  obj.correctExtraArray = correctExtraArray;
  if (kungKenoCorrect && arr.kungKeno) {
    obj.kungKenoCorrect = arr.kungKeno;
  }
  return obj;
};

 })(window);